import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

/**
 * This interceptor injects the basic HTTP authorization header into any outgoing API requests.
 */
@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

// #region [ Implemented Methods ]

	/**
	 * Intercepts outbound HTTP requests and injects the basic HTTP authorization header.
	 * @param Request
	 * @param Next
	 */
	public intercept(Request: HttpRequest<any>, Next: HttpHandler): Observable<HttpEvent<any>> {
		let objRequest: HttpRequest<any>;
		let strBasicAuth: string;

		strBasicAuth = window.btoa(environment.BasicAuthUserName + ":" + environment.BasicAuthPassword)
		objRequest = Request.clone({
			setHeaders: {
				Authorization: `Basic ${strBasicAuth}`
			}
		});

		return Next.handle(objRequest);
	}
}